"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
var _withSizePresets = _interopRequireDefault(require("../withSizePresets"));
/* eslint-disable max-len */

var InStore = function InStore(props) {
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, (0, _extends2["default"])({
    viewBox: "0 0 31 30"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,1.73954621 L14.8003932,8.692515 L14.8003932,30 L11.8416396,28.6086238 L11.8416396,18.3604277 L2.95742862,14.1862992 L2.95742862,24.4371034 L0,23.0470312 L0,1.73954621 Z M31,9.09936538 L30.9178492,23.0470312 L16.7879125,29.7822307 L16.8700633,15.8371729 L31,9.09936538 Z M14.7977432,-4.54747351e-13 L30.9178492,7.07293749 L16.6077107,13.5199513 L16.6540862,7.68582109 L6.85561634,3.26914718 L14.7977432,-4.54747351e-13 Z"
  })));
};
var _default = (0, _withSizePresets["default"])(23, 24)(InStore);
exports["default"] = _default;
//# sourceMappingURL=InStore.js.map